// extracted by mini-css-extract-plugin
module.exports = {"label":"ht1Z","icon":"XGDe"};